import { createReducer } from '../../../utilities';

import { scope, RESET_CREATE_LFP_GAME } from '../../../../actions/app/onSite/lfpGame/create';
import {
    REQUEST_CREATE_LFP_GAME,
    SUCCESS_CREATE_LFP_GAME,
    FAIL_CREATE_LFP_GAME
} from '../../../../actions/entities/lfpGame';

const initialLfpGameCreateState = {
    id: null,
    info: {
        isPosting: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isPosting: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { id, payload, receivedAt, success } = action;
    return {
        ...state,
        id: id || state.id,
        info: {
            ...state.info,
            isPosting: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload, type } = action;
    return {
        ...state,
        id: type === FAIL_CREATE_LFP_GAME ? null : state.id,
        info: {
            ...state.info,
            isPosting: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

function reset() {
    return initialLfpGameCreateState
}

export default createReducer(initialLfpGameCreateState, {
    [REQUEST_CREATE_LFP_GAME]: request,
    [SUCCESS_CREATE_LFP_GAME]: success,
    [FAIL_CREATE_LFP_GAME]: fail,
    [RESET_CREATE_LFP_GAME]: reset
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/lfpGame/create.js